import React, { useCallback, useEffect, useState } from "react";
import {
    Card,
    Table,
    Tag,
    Button,
    Space,
    Popconfirm,
    message,
    Typography,
} from "antd";
import { ReloadOutlined, DeleteOutlined, CheckOutlined } from "@ant-design/icons";
import { api } from "../api";
import { fmtDate } from "../utils";

const { Paragraph } = Typography;

const FeedbackPage = () => {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);

    const load = useCallback(async () => {
        setLoading(true);
        try {
            const res = await api.listFeedback();
            setItems(res.items);
        } catch (e) {
            message.error(e.message);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        load();
    }, [load]);

    const markRead = async (id) => {
        try {
            await api.markFeedbackRead(id, true);
            setItems((prev) =>
                prev.map((it) => (it._id === id ? { ...it, read: true } : it))
            );
        } catch (e) {
            message.error(e.message);
        }
    };

    const remove = async (id) => {
        try {
            await api.deleteFeedback(id);
            setItems((prev) => prev.filter((it) => it._id !== id));
            message.success("Deleted");
        } catch (e) {
            message.error(e.message);
        }
    };

    const columns = [
        {
            title: "Status",
            dataIndex: "read",
            key: "read",
            width: 90,
            render: (read) =>
                read ? <Tag>Read</Tag> : <Tag color="blue">New</Tag>,
        },
        { title: "Name", dataIndex: "fullName", key: "fullName" },
        {
            title: "Contact",
            key: "contact",
            render: (_, r) => (
                <div>
                    <div>
                        <a href={`mailto:${r.email}`}>{r.email}</a>
                    </div>
                    <div className="admin-cell-sub" style={{ color: "#64748b" }}>
                        {r.mobileNumber}
                    </div>
                </div>
            ),
        },
        {
            title: "Message",
            dataIndex: "message",
            key: "message",
            render: (m) => (
                <Paragraph
                    style={{ margin: 0, maxWidth: 360 }}
                    ellipsis={{ rows: 3, expandable: true, symbol: "more" }}
                >
                    {m}
                </Paragraph>
            ),
        },
        {
            title: "Received",
            dataIndex: "createdAt",
            key: "createdAt",
            width: 170,
            render: (d) => fmtDate(d, true),
        },
        {
            title: "Actions",
            key: "actions",
            width: 150,
            render: (_, r) => (
                <Space>
                    {!r.read && (
                        <Button
                            size="small"
                            icon={<CheckOutlined />}
                            onClick={() => markRead(r._id)}
                        >
                            Read
                        </Button>
                    )}
                    <Popconfirm
                        title="Delete this message?"
                        onConfirm={() => remove(r._id)}
                    >
                        <Button size="small" danger icon={<DeleteOutlined />} />
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    return (
        <div>
            <h1 className="admin-page-title">Feedback</h1>
            <Card
                variant="borderless"
                title="Contact form submissions"
                extra={
                    <Button
                        size="small"
                        icon={<ReloadOutlined />}
                        loading={loading}
                        onClick={load}
                    >
                        Refresh
                    </Button>
                }
            >
                <Table
                    rowKey="_id"
                    size="small"
                    loading={loading}
                    columns={columns}
                    dataSource={items}
                    scroll={{ x: "max-content" }}
                    pagination={{ pageSize: 10 }}
                />
            </Card>
        </div>
    );
};

export default FeedbackPage;
